// src/services/usuarioService.js
import { collection, getDocs, doc, deleteDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../firebaseConfig";

// Obtener usuarios
export const getUsuarios = async () => {
  const usuariosSnapshot = await getDocs(collection(db, "medicos"));
  const usuarios = usuariosSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  return usuarios;
};

// Eliminar usuario
export const deleteUsuario = async (usuarioId) => {
  await deleteDoc(doc(db, "medicos", usuarioId));
};

// Actualizar usuario (sede y foto)
export const updateUsuario = async (usuarioId, updatedFields) => {
  // Si hay una nueva foto, la subimos y actualizamos el campo correspondiente
  if (updatedFields.nuevaFoto) {
    const nuevaFoto = updatedFields.nuevaFoto;
    const fotoRef = ref(storage, `medicos/${usuarioId}/${nuevaFoto.name}`);
    await uploadBytes(fotoRef, nuevaFoto);
    const fotoURL = await getDownloadURL(fotoRef);
    updatedFields.profileImage = fotoURL;
    delete updatedFields.nuevaFoto;
  }

  // Actualizar los campos en Firestore
  await updateDoc(doc(db, "medicos", usuarioId), updatedFields);
};
